import { useState, useCallback } from 'react';
import { v4 as UUIDv4 } from 'uuid';
import { FileRejection } from 'react-dropzone';
import { FileWithPath } from '@mantine/dropzone';
import { Errors, TFile } from '../types';
import { appInsights } from '../tracking/appInsights';
import { FileErrorAlert } from '../helpers/fileHelper';

export const useFileHandler = (fileUploadErrorTexts: Errors) => {
  const [droppedFiles, setDroppedFiles] = useState<TFile[]>([]);

  const handleOnFileAccepted = (files: FileWithPath[]) => {
    const tempAcceptedFiles: TFile[] = files.map((x) => {
      const tempFile: TFile = {
        id: UUIDv4(),
        file: x as File,
      };
      return tempFile;
    });
    setDroppedFiles((prevs) => [...prevs, ...tempAcceptedFiles]);
  };

  const handleOnFileRejected = (files: FileRejection[]) => {
    files.forEach((file) => {
      FileErrorAlert(file.file.name, file.errors[0]?.code, fileUploadErrorTexts);
      appInsights.trackEvent(
        { name: 'rejectedFile' },
        { file: { name: file.file.name, size: file.file.size }, errorCode: file.errors[0]?.code },
      );
    });
  };

  const removeFile = useCallback(
    (id: string) => {
      const newDroppedFiles = droppedFiles.filter((item) => item.id !== id);
      setDroppedFiles(newDroppedFiles);
    },
    [droppedFiles],
  );

  const clearAllFiles = () => {
    setDroppedFiles([]);
  };

  return {
    handleOnFileAccepted,
    handleOnFileRejected,
    removeFile,
    droppedFiles,
    clearAllFiles,
  };
};
